import { ModalWindow, Checkbox, Div, RefBool, ProgressBar, RefBase, RefWatcher } from "@tblabs/truffle";
import { PrimaryButton } from "../Components/General/Buttons/PrimaryButton";
import { Translations } from "../Translations/Translations";
import { ICamera } from "../Services/Camera/ICamera";
import { Throttle } from "../Utils/Throttle/Throttle";
import { InfoBox } from "../Components/General/InfoBox";


export class CameraSettingsWindow extends ModalWindow
{
    private vibrationEnabled = new RefBool();
    private touchToVibrationLoopbackEnabled = new RefBool();
    private startupVibrationEnabled = new RefBool();
    private connectionVibrationEnabled = new RefBool();

    private throttle = new Throttle({ Interval: 10, Steps: 100 });

    constructor(_lang: Translations, private _camera: ICamera)
    {
        super(_lang.CameraSettings, true, false, true);

        if (!this._camera.Config?.Io)
        {
            this.AddContent(new InfoBox(_lang.CameraSettingsNotAvailable)); 
            this.AddToFooter(
                new PrimaryButton("OK").OnClick(() => this.CloseWindow()),
            );
            this.OpenWindow();
            return;
        }

        this.vibrationEnabled.value = this._camera.Config.Io?.VibrationEnabled ?? false;
        this.touchToVibrationLoopbackEnabled.value = this._camera.Config.Io?.TouchToVibrationLoopbackEnabled ?? false;
        this.startupVibrationEnabled.value = this._camera.Config.Io?.StartupVibrationEnabled ?? false;
        this.connectionVibrationEnabled.value = this._camera.Config.Io?.ConnectionVibrationEnabled ?? false;

        RefWatcher.Watch([
            this.vibrationEnabled,
            this.touchToVibrationLoopbackEnabled,
            this.startupVibrationEnabled,
            this.connectionVibrationEnabled],
            () => this.SendSettingsToCamera(), false);

        this.AddContent(
            new ProgressBar(this.throttle.ProgressPercent),
            new Checkbox(this.vibrationEnabled, _lang.VibrationsEnabled),
            new Div().PaddingLeft(32).MarginTop(8).Style("display: flex; flex-direction: column; gap: 8px;")
                .Append(
                    new Checkbox(this.touchToVibrationLoopbackEnabled, _lang.VibrateOnSensorTouch)
                        .Enable(this.vibrationEnabled),
                    new Checkbox(this.startupVibrationEnabled, _lang.VibrateOnStartup)
                        .Enable(this.vibrationEnabled),
                    new Checkbox(this.connectionVibrationEnabled, _lang.VibrateOnConnection)
                        .Enable(this.vibrationEnabled)
                )
        );

        this.AddToFooter(
            new PrimaryButton(_lang.Close).OnClick(() => this.CloseWindow()),
        );

        this.OpenWindow();
    }

    private SendSettingsToCamera(): void
    {
        this.throttle.CallLater(() =>
        {
            const configUpdate = {
                Io: {
                    VibrationEnabled: this.vibrationEnabled.value,
                    TouchToVibrationLoopbackEnabled: this.touchToVibrationLoopbackEnabled.value,
                    StartupVibrationEnabled: this.startupVibrationEnabled.value,
                    ConnectionVibrationEnabled: this.connectionVibrationEnabled.value,
                }
            };
            // console.log('configUpdate', configUpdate);
            this._camera.UpdateSettings(configUpdate);
        });
    }
}